/* eslint-disable import/first */
require('typeface-roboto')
import React from "react";
import { Flex } from 'rebass';
import Terminals from '../components/terminals';
import Objectives from '../components/objectives';
import Intro from '../components/intro';
import TopNav from '../components/topNav';
import Footer from '../components/footer';
import TheEnd from '../components/theEnd'
import '../components/layout.css'

const IndexPage = () => (
  <Flex id='lol' flexDirection='column' bg='#3F4347' fontFamily='Roboto'>
    <TopNav />
    <Intro />
    <Objectives />
    <Terminals />
    <TheEnd />
    <Footer />
  </Flex>
);

export default IndexPage;
